import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import ViewEmployee from "../view";

const assignedAssetRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Assigned Assets",
		basePath: "employees/:employeeId/assigned-assets",
		mainComponent: <ViewEmployee />,
	    layout: "/console",	
	    subTitle:"Assigned Asset",
		level:3,
		moduleId: 0,
	})
]

export default assignedAssetRoutes;